export const responsiveWidthFunction = ({ width }: { width: number }) => {
  if (width > 839) return 3
  if (width > 599) return 2
  return 1
}
